import React, { useState } from "react";
import { Anchor, Box, Group, Text, UnstyledButton } from "@mantine/core";
import { useAppContext } from "../../Context/AppContext";
import { formatClock } from "./Footer";
import classes from "./LoginBuildChip.module.css";
// The logged-out footer: a copyright line plus a build chip that opens the same
// diagnostics the logged-in Footer.tsx prints in its second column, and that
// welcome-footer.tpl has always shown on the Smarty logged-out pages. Separate
// from Footer.tsx because that one is a port of trailer.tpl — four columns of
// support options, accSync state and a live-chat button gated on
// appData.user.chat, none of which exists before authentication.
export default function LoginBuildChip() {
    const { appData } = useAppContext();
    const [open, setOpen] = useState(false);
    // Same treatment as the logged-in Footer.tsx chip: a friendly release label
    // (ISN::getVersionLabel()) when keystone has written one for this build, otherwise the
    // buildId/taskId identity already shown below as `server {appData.webServer}`. Never the
    // raw `build` (VERSION) days-since-2002 counter.
    const fullServerLabel = [appData.buildId, appData.taskId].filter(Boolean).join('/');
    const chipHeadline = `build ${appData.versionLabel || appData.webServer}`;
    const copyFullServerLabel = () => {
        if (fullServerLabel && navigator.clipboard) {
            navigator.clipboard.writeText(fullServerLabel).catch(() => { });
        }
    };
    return (React.createElement(Box, { component: "footer", className: classes.root },
        React.createElement(Group, { justify: "space-between", gap: "12px 24px", wrap: "wrap", className: classes.row },
            React.createElement(Group, { gap: 8, wrap: "wrap" },
                React.createElement(Text, { size: "xs", c: "dimmed" },
                    "\u00A9 ",
                    new Date().getFullYear(),
                    " Inspection Support, LLC"),
                React.createElement(Text, { size: "xs", className: classes.sep }, "|"),
                React.createElement(Anchor, { size: "xs", c: "dimmed", href: "https://www.inspectionsupport.com/privacy/", target: "_blank", rel: "external" }, "Privacy"),
                React.createElement(Text, { size: "xs", className: classes.sep }, "|"),
                React.createElement(Anchor, { size: "xs", c: "dimmed", href: "https://www.inspectionsupport.com/isn-terms-of-service/", target: "_blank", rel: "external" }, "Terms")),
            React.createElement(UnstyledButton, { className: classes.chip, onClick: () => setOpen((o) => !o), "aria-expanded": open, title: fullServerLabel || undefined },
                React.createElement("span", { className: classes.dot }),
                React.createElement("span", null, chipHeadline),
                React.createElement("span", { "aria-hidden": "true" }, open ? "▴" : "▾"))),
        open && (React.createElement(Group, { gap: "6px 28px", wrap: "wrap", className: classes.drawer },
            React.createElement(UnstyledButton, { className: classes.copyRow, onClick: copyFullServerLabel, disabled: !fullServerLabel, title: fullServerLabel ? `Copy ${fullServerLabel}` : undefined },
                "server ",
                appData.webServer),
            React.createElement("span", null,
                "rendered in ",
                appData.processingSeconds,
                "s"),
            React.createElement("span", null,
                formatClock(appData.timeLocal, appData.timeZone),
                " local"),
            React.createElement("span", null,
                formatClock(appData.timeGMT, "UTC"),
                " UTC")))));
}
